<template>
    <v-navigation-drawer
        :value="visible"
        temporary
        touchless
        :right="!$vuetify.rtl"
        :width="$vuetify.breakpoint.smAndUp ? 550 : '100%'"
        @input="v=>{$emit('input', v)}"
        app>
        <v-card height="100%">
            <div class="drawer-header d-flex align-center mb-4">
                <span class="font-weight-semibold text-base text--primary">{{$t('log.details')}}</span>
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    small
                    @click="$emit('handleCancel')"
                    >
                    <v-icon size="22">
                        {{ icons.mdiClose }}
                    </v-icon>
                </v-btn>
            </div>

            <v-simple-table :class="$vuetify.theme.dark ? 'simple-table-box simple-table-dark':'simple-table-box'" dense>
                <template v-slot:default>
                    <tbody>
                      <template v-for="(item, index) in userList">
                        <tr v-if="item.value != 'appUsername' || (item.value == 'appUsername' && infoData[item.value])":key="index">
                          <td class="details-label-l">{{item.text}}</td>
                          <td>
                            <span class="text--secondary" v-if="item.type=='time'">{{ infoData[item.value] ? moment(infoData[item.value] * 1000).format('YYYY-MM-DD HH:mm:ss') : null }}</span>
                            <span class="text--secondary" v-else>{{ infoData[item.value] }}</span>
                          </td>
                        </tr>

                      </template>

                    </tbody>
                </template>
            </v-simple-table>
        </v-card>
    </v-navigation-drawer>
</template>

<script>
import moment from 'moment';
import { mdiClose } from '@mdi/js'

export default {
    data() {
        return {
			userList: [
                {
                    text: this.$t('log.columns.appUsername'),
                    value: 'appUsername',
                    align: "center",
                    ellipsis: true,
                    sortable: false,
                },
              {
                    text: this.$t('log.columns.descp'),
                    value: 'descp',
                    align: "center",
                    ellipsis: true,
                    sortable: false,
                },
                {
                    text: this.$t('log.columns.logTime'),
                    value: 'logTime',
                    align: "center",
                    ellipsis: true,
                    sortable: false,
                    type: "time"
                },
                {
                    text: this.$t('log.columns.actionType'),
                    value: 'actionType',
                    align: "center",
                    ellipsis: true,
                    sortable: false,
                },
                {
                    text: this.$t('log.columns.actionObject'),
                    value: 'actionObject',
                    align: "center",
                    ellipsis: true,
                    sortable: false,
                },
                {
                    text: this.$t('log.columns.device'),
                    value: 'device',
                    align: "center",
                    ellipsis: true,
                    sortable: false,
                },
                {
                    text: this.$t('log.columns.browser'),
                    value: 'browser',
                    align: "center",
                    ellipsis: true,
                    sortable: false,
                },
                {
                    text: this.$t('log.columns.location'),
                    value: 'location',
                    align: "center",
                    ellipsis: true,
                    sortable: false,
                },
                {
                    text: this.$t('log.columns.ip'),
                    value: 'ip',
                    align: "center",
                    ellipsis: true,
                    sortable: false,
                },
               {
                    text: this.$t('log.columns.resultReason'),
                    value: 'resultReason',
                    align: "center",
                    ellipsis: true,
                    sortable: false,
                },
                {
                    text: this.$t('log.columns.result'),
                    value: 'result',
                    align: "center",
                    ellipsis: true,
                    sortable: false,
                },
			],
            icons: {
                mdiClose
            }
        };
    },
    props: {
        visible: Boolean,
        infoData: Object,
    },
    created() {
    },
    methods: {
        moment,
        handleCancel() {
            this.$emit("handleCancel")
        }
    },
}
</script>

<style lang='scss' scoped>
    .limit_th_width ::v-deep {
        .ant-descriptions-item-label {
            white-space: nowrap;

        }
    }
    .ant-descriptions-bordered.ant-descriptions-small .ant-descriptions-item-content ::v-deep{
        white-space: normal;
        word-break: break-all;
    }
    ::v-deep{
        .v-data-table__wrapper{
            height: 100% !important;
        }
    }
    ::v-deep {
        .v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td{
            white-space: normal !important;
        }
    }
</style>
